import type { CampaignModel, ServiceProductModel } from '@models/types'

type CheckProductRequiredCampaignFieldsParams = {
  campaign: CampaignModel,
  serviceProduct: ServiceProductModel,
}

const checkProductRequiredCampaignFields = (params: CheckProductRequiredCampaignFieldsParams) => {
  const { campaign, serviceProduct } = params

  const requiredCampaignFields = serviceProduct?.options?.required_campaign_fields || []

  if (!requiredCampaignFields.length || !campaign?.id){
    return { missingFields: [], requiredCampaignFields: [] }
  }

  const missingFields = requiredCampaignFields.filter(field => !campaign[field])

  return { missingFields, requiredCampaignFields }
}

export default checkProductRequiredCampaignFields
